import api, { adminApiPrefix } from './Api';
import {
  ShippingProvider,
  shippingProviderFromResponse,
  shippingProviderToUpsertRequest,
} from '../interfaces/ShippingProvider/ShippingProvider';

const shippingProviderAdminApiPrefix = `${adminApiPrefix}/shipping-providers`;

export const createShippingProvider = async (
  shippingProvider: ShippingProvider,
): Promise<ShippingProvider> => {
  const response = await api.post(
    shippingProviderAdminApiPrefix,
    shippingProviderToUpsertRequest(shippingProvider),
  );

  return shippingProviderFromResponse(response.data?.data);
};

export const getShippingProviders = async (): Promise<ShippingProvider[]> => {
  const response = await api.get(shippingProviderAdminApiPrefix);

  return (response.data?.data ?? []).map((sp: any) =>
    shippingProviderFromResponse(sp),
  );
};

export const getShippingProvider = async (
  id: number,
): Promise<ShippingProvider> => {
  const response = await api.get(`${shippingProviderAdminApiPrefix}/${id}`);

  return shippingProviderFromResponse(response.data?.data);
};

export const updateShippingProvider = async (
  shippingProvider: ShippingProvider,
): Promise<ShippingProvider> => {
  const response = await api.put(
    `${shippingProviderAdminApiPrefix}/${shippingProvider.id}`,
    shippingProviderToUpsertRequest(shippingProvider),
  );

  return shippingProviderFromResponse(response.data?.data);
};

export const deleteShippingProvider = async (id: number): Promise<void> =>
  api.delete(`${shippingProviderAdminApiPrefix}/${id}`);
